import $ from 'jquery';
import ko from 'knockout';
import logger from '../Utils/logger';

/**
 * Binding to make an element act as a drop zone for file/folder uploads. Child elements within the element will
 * trigger the "dragleave" so a counter is used to determine when enter and leave events occurs just on
 * the element and not child elements.
 */
export const uploadDropZone = {
  init: function (element, valueAccessor) {

    var dropZoneElement = $(element);
    var addFileUploadsCallback = valueAccessor();
    var counter = 0;

    dropZoneElement.on('dragover', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    dropZoneElement.on('dragenter', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter++;

      dropZoneElement.css('background-color', '#FDFFB7');
      dropZoneElement.css('border-style', 'dashed');
    });

    dropZoneElement.on('dragleave', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter--;

      if (counter === 0) {
        dropZoneElement.css('background-color', '');
        dropZoneElement.css('border-style', 'solid');
      }
    });

    dropZoneElement.on('drop', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter = 0;
      dropZoneElement.css('background-color', '');
      dropZoneElement.css('border-style', 'solid');

      getFiles(e.originalEvent.dataTransfer.items)
        .then(function (files) {
          if (files && files.length > 0) {
            addFileUploadsCallback(files);
          } else if (files) {
            logger.warning('EmptyFolderUploadWarningMessage');
          }
        })
        .catch(function (error) {
          logger.error(
            'UnhandledError',
            'An unexpected error occurred while attempting add file or folder uploads.', error);
        });
    });

    function getFiles(items) {
      return new Promise(function (resolve, reject) {

        var promises = [];

        ko.utils.arrayForEach(items, function (item) {
          var entry = null;

          // try to read item as entry. `webkitGetAsEntry` method can we deprecated and removed soon
          if (item.webkitGetAsEntry) {
            entry = item.webkitGetAsEntry();
          } else if (item.getAsEntry) {
            entry = item.getAsEntry();
          }

          // In order to add support of files drag'n'drop please remove `entry.isDirectory` verification.
          if (entry && entry.isDirectory) {
            promises.push(scanFiles(entry));
          }
        });

        Promise.all(promises)
          .then(function (result) {
            var files = flattenDeep(result);
            resolve(files);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }

    function scanFiles(item) {
      return new Promise(function (resolve, reject) {
        if (item.isFile) {
          item.file(function (file) {
            // webkitRelativePath was missing
            var webkitRelativePath = item.fullPath.substring(1, item.fullPath.length);
            Object.defineProperty(file, 'webkitRelativePath', {
              value: webkitRelativePath
            });
            resolve(file);
          });
        } else {
          var reader = item.createReader();
          readEntries(reader)
            .then(successCallback)
            .catch(errorCallback);
        }

        function successCallback(entries) {
          var promises = [];

          ko.utils.arrayForEach(entries, function (entry) {
            promises.push(scanFiles(entry));
          });

          Promise.all(promises)
            .then(function (result) {
              var files = result;
              resolve(files);
            })
            .catch(function (error) {
              reject(error);
            });
        }

        function errorCallback(error) {
          reject(error);
        }

        function readEntries(directoryReader) {
          return new Promise(function (resolve, reject) {
            directoryReader.readEntries(
              function (entries) {
                if (entries.length > 0) {
                  readEntries(directoryReader)
                    .then(function (result) {
                      resolve(entries.concat(result));
                    })
                    .catch(function (err) {
                      reject(err);
                    });
                } else {
                  resolve(entries);
                }
              },
              function (error) {
                reject(error);
              }
            );
          });
        }
      });
    }

    function flattenDeep(arr) {
      return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flattenDeep(toFlatten) : toFlatten);
      }, []);
    }
  }
};
